 <template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title>
      <div v-if="partsRequest" class="mt-5">
        <div class="vx-row mb-6">
          <div class="vx-col">
            <p>Código Pedido:</p>
          </div>
          <div class="vx-col">
            <vs-chip color="success">{{ partsRequest.idPartsRequest }}</vs-chip>
          </div>
          <div class="vx-col">
            <p>Cliente</p>
          </div>
          <div class="vx-col">
            <vs-chip color="success">{{ partsRequest.corporateName }}</vs-chip>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <p>Etapa</p>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-radio color="#1E90FF" v-model="newStage" vs-value="Conferência"
              >Conferência</vs-radio
            >
          </div>
          <div class="vx-col">
            <vs-radio
              color="success"
              v-model="newStage"
              vs-value="Entregue ao Solicitante"
              >Entregue ao Solicitante</vs-radio
            >
          </div>
          <div class="vx-col">
            <vs-radio color="warning" v-model="newStage" vs-value="Concluído"
              >Concluído</vs-radio
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-list>
              <vs-list-header title="Histórico" color="danger"></vs-list-header>
              <div v-for="(item, index) of stages" :key="index">
                <vs-list-item
                  icon-pack="feather"
                  icon="icon-check"
                  title="Data"
                  :subtitle="item.date"
                ></vs-list-item>
                <vs-list-item :title="item.userName" :subtitle="item.note">
                  <template slot="avatar">
                    <vs-avatar :src="item.photo" />
                  </template>
                </vs-list-item>
              </div>
            </vs-list>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              name="newNote"
              label-placeholder="Observação"
              v-model="newNote"
            />
          </div>
        </div>
        <vs-button
          class="mr-6"
          icon-pack="feather"
          icon="icon-save"
          @click="submitData()"
          >Salvar</vs-button
        >
      </div>
    </vx-card>
  </div>
</template> 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { momentJS } from "@/helpers";
import router from "@/router";
export default {
  data() {
    return {
      partsRequest: null,
      newStage: null,
      stages: [],
      newNote: null,
    };
  },
  methods: {
    async submitData() {
      try {
        if (!this.newNote) {
          this.newNote = "Nenhuma Observação";
        }

        let data = {
          partsRequest: {
            stage: this.newStage,
            idPartsRequest: this.partsRequest.idPartsRequest,
          },
          stage: {
            note: `${this.newStage} - ${this.newNote}`,
            date: momentJS().getDateTime(),
            fk_idPartsRequest: this.partsRequest.idPartsRequest,
            fk_idUser: this.$store.state.user.idUser,
          },
        };
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/partsRequest/editStage`,
          data
        );
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
         router.push("/solicitacao").catch(() => {});
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async getStagePartsRequestById() {
      this.$vs.loading();
      try {
        const response = await axios.get(
          `${baseApiUrl}/partsRequest/getStagePartsRequestById/${this.$route.params.idPartsRequest}`
        );
        this.partsRequest = response.data.partsRequest;
        this.newStage = response.data.partsRequest.stage;
        this.stages = response.data.stages;
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    await this.getStagePartsRequestById();
  },
};
</script> 
